export default __webpack_public_path__ + "static/media/blink.ea4fd8ce.png";